import { render } from "./data_grid.vue?vue&type=template&id=70c98641&scoped=true&ts=true"
import script from "./data_grid.vue?vue&type=script&lang=ts&config=true"
export * from "./data_grid.vue?vue&type=script&lang=ts&config=true"

import "./data_grid.vue?vue&type=style&index=0&id=70c98641&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c98641"]])

export default __exports__